import { TASK_REASSIGN_INITIALIZE } from '../../../actions/page/tasks/TaskReassign';
import {
  UPDATE_TASK_REQUEST,
  UPDATE_TASK_SUCCESS,
  UPDATE_TASK_FAILURE
} from '../../../actions/api/task';

export default function TaskReassign(state = {}, action) {
  switch (action.type) {
    case TASK_REASSIGN_INITIALIZE:
      return {
        ...state,
        saving: false,
        error: false,
        reassigned: false
      };
    case UPDATE_TASK_REQUEST:
      return {
        ...state,
        saving: true,
        reassigned: false,
        error: false
      };
    case UPDATE_TASK_SUCCESS:
      return {
        ...state,
        saving: false,
        reassigned: true,
        error: false
      };
    case UPDATE_TASK_FAILURE:
      return {
        ...state,
        saving: false,
        reassigned: false,
        error: action.error
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/page/tasks/TaskReassign.js